import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M10 18L4 18L4 6L10 6L10 18Z" fill="currentColor" stroke="none" />
		<Path d="M13 9.25H20M20 14.75H13" vectorEffect="non-scaling-stroke" />
	</SVG>
);
